<template>
  <div
    class="flex h-40 max-w-full flex-col items-center justify-center border border-dashed border-gray-300 bg-gray-50 p-2 lg:h-52"
    @drop.prevent="addFileFromDragEvent"
    @dragenter.prevent
    @dragover.prevent
  >
    <div
      class="mb-2 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100"
    >
      <div
        class="flex h-16 w-16 items-center justify-center rounded-full bg-blue-100"
      >
        <icon-base width="30" height="30" icon="upload-file" />
      </div>
    </div>
    <input
      id="upload-box-browse"
      :accept="accept"
      class="hidden"
      data-cy="documents-upload-box"
      multiple
      :type="disabled ? undefined : 'file'"
      @change="addFileFromBrowse"
    />
    <div class="max-w-[300px] text-center text-sm">
      <span>
        {{ $t("DEALS.DOCUMENTS.UPLOAD_TEXT_3", { docTypes: accept }) }}
      </span>
      <label for="upload-box-browse" class="cursor-pointer text-blue-500">
        {{ ` ${$t("DEALS.DOCUMENTS.UPLOAD_TEXT_BROWSE")} ` }}
      </label>
      <span>{{ $t("DEALS.DOCUMENTS.UPLOAD_TEXT_2") }}</span>
    </div>
    <slot name="fileInfo" />
  </div>
</template>

<script lang="ts" setup>
const { accept, disabled } = defineProps<{
  accept: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  "files:add": [files: FileList];
}>();

const addFileFromBrowse = (event: Event) => {
  const files = (event.target as HTMLInputElement)?.files;

  if (!files?.length) {
    return;
  }

  emit("files:add", files);

  // Set the input value to null because otherwise
  // onChange won't work next time you select the same file.
  (event.target as HTMLInputElement).value = "";
};

const addFileFromDragEvent = (event: DragEvent) => {
  if (disabled || !event?.dataTransfer) {
    return;
  }

  emit("files:add", event.dataTransfer.files);
};
</script>
